/* PRO AIR TOOLS: bigger-orders scripts (2026-10-01)
   1) Kit picker on product pages (snippets/pat-kit-picker.liquid)
   2) Cart add-ons: kit "Switch" and "+ Add" (snippets/pat-cart-addons.liquid)
   Event delegation on document, so it keeps working after the theme
   re-renders the cart drawer. No other theme script is changed. */
(function () {
  if (window.__patBiggerOrders) return;
  window.__patBiggerOrders = true;

  /* ---------- click tracking (2026-10-06) ----------
     Sends a named event to Microsoft Clarity for each use of the picker,
     Switch and + Add. Tracking only: never changes what the shopper sees.
     Events: pat_picker_kit, pat_picker_single, pat_switch_click, pat_switch_ok,
     pat_addon_click, pat_addon_ok, pat_refresh_retry, pat_action_fail. */
  function track(name, tagKey, tagVal) {
    try {
      if (typeof window.clarity === 'function') {
        if (tagKey) window.clarity('set', tagKey, String(tagVal));
        window.clarity('event', name);
      }
    } catch (err) {}
  }

  /* ---------- 1) kit picker ---------- */
  function pickerIds(picker) {
    return Array.prototype.map.call(picker.querySelectorAll('[data-pat-kp-input]'), function (i) { return i.value; });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-pat-kp-input]');
    if (!input) return;
    var picker = input.closest('[data-pat-kit-picker]');
    var ids = pickerIds(picker);
    picker.querySelectorAll('[data-pat-kp-row]').forEach(function (r) {
      r.classList.toggle('is-on', r.contains(input));
    });
    if (String(input.value) === String(picker.getAttribute('data-base-variant'))) {
      track('pat_picker_single');
    } else {
      track('pat_picker_kit', 'pat_picker_variant', input.value);
    }
    // every add-to-cart form on the page that currently holds this product or one of its kits
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (el) {
      if (el.tagName === 'SELECT') return;
      if (ids.indexOf(String(el.value)) !== -1) el.value = input.value;
    });
  });

  /* ---------- 2) cart add-ons ---------- */
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function refreshCart() {
    var path = window.location.pathname;
    var wantPage = !!document.getElementById('main-cart-items');
    var sections = ['form-mini-cart'];
    var pageSectionId = wantPage ? document.getElementById('main-cart-items').dataset.id : null;
    if (pageSectionId) sections.push(pageSectionId);
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count;
        });
        return fetch(path + (path.indexOf('?') === -1 ? '?' : '&') + 'sections=' + sections.join(','));
      })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var parser = new DOMParser();
        if (json['form-mini-cart']) {
          var html = parser.parseFromString(json['form-mini-cart'], 'text/html');
          var src = html.querySelector('#form-mini-cart');
          var dst = document.querySelector('#form-mini-cart');
          if (src && dst) dst.innerHTML = src.innerHTML;
        }
        if (pageSectionId && json[pageSectionId]) {
          var html2 = parser.parseFromString(json[pageSectionId], 'text/html');
          var s2 = html2.querySelector('.js-contents');
          var d2 = document.querySelector('#main-cart-items .js-contents');
          if (s2 && d2) d2.innerHTML = s2.innerHTML;
        }
        var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (drawer && typeof drawer.cartAction === 'function') { try { drawer.cartAction(); } catch (err) {} }
        if (window.BlsLazyloadImg && BlsLazyloadImg.init) { try { BlsLazyloadImg.init(); } catch (err) {} }
      });
  }

  function busy(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('is-busy', on);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-pat-addon]');
    var swap = e.target.closest && e.target.closest('[data-pat-swap]');
    if (!add && !swap) return;
    e.preventDefault();
    var btn = add || swap;
    if (btn.disabled) return;
    busy(btn, true);
    var trackId = add ? add.getAttribute('data-pat-addon') : swap.getAttribute('data-add');
    if (swap) track('pat_switch_click', 'pat_switch_variant', trackId);
    else track('pat_addon_click', 'pat_addon_variant', trackId);

    var addId = add ? add.getAttribute('data-pat-addon') : swap.getAttribute('data-add');
    var job = fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(addId), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });

    if (swap) {
      // only after the kit is safely in the cart, lower the single items it replaces
      job = job.then(function () {
        var updates = {};
        (swap.getAttribute('data-removes') || '').split(',').forEach(function (pair) {
          if (!pair) return;
          var i = pair.lastIndexOf(':');
          updates[pair.slice(0, i)] = Math.max(0, parseInt(pair.slice(i + 1), 10) || 0);
        });
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      });
    }

    job.then(function () {
        // the cart itself has changed at this point; count it before the panel refresh
        track(swap ? 'pat_switch_ok' : 'pat_addon_ok');
        return refreshCart().catch(function (err) {
          track('pat_refresh_retry');
          return refreshCart();
        });
      })
      .then(function () {
        busy(btn, false);
        if (btn.hasAttribute('data-pat-open-cart')) {
          var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (err) {} }
        }
      })
      .catch(function () {
        track('pat_action_fail');
        btn.textContent = 'Try again';
        busy(btn, false);
        return refreshCart();
      });
  });
})();
